// Bulk quantity discount removed — no automatic per-quantity discount.
export const TIERS = [];

export function qtyDiscount() {
  return 0;
}

export function lineOriginal(price, qty) {
  return price * qty;
}

export function lineTotal(price, qty) {
  const unit = Math.round(price * (1 - qtyDiscount(qty)) * 100) / 100;
  return unit * qty;
}
